import React from "react";
import { useCloseConfirmation } from "../../../hooks/useCloseConfirmation";
import CloseConfirmationModal from "../CloseConfirmationModal/CloseConfirmationModal";

type Props = {
  onClose?: () => void;
};

const CloseAction: React.FC<Props> = ({ onClose }) => {
  const {
    showCancelConfirm,
    handleCloseClick,
    handleConfirm,
    handleModalClose
  } = useCloseConfirmation(onClose);

  return (
    <>
      {/* Close Button */}
      <button
        onClick={handleCloseClick}
        className="fixed top-4 right-4 text-gray-600 hover:text-gray-900 z-50"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      {/* Cancel Confirmation Modal */}
      <CloseConfirmationModal
        open={showCancelConfirm}
        onClose={handleModalClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default CloseAction;
